/**
 * @file Single Product.
 */

/**
 * Single Product component.
 */
const singleProduct = () => {
	const singleProductPage = document.querySelector('.v-simple-product');

	if (!singleProductPage) {
		return;
	}

	const productNotice = document.querySelector(
		'.wc-block-components-notice-banner',
	);

	const thwepoFileInput = document.querySelector('.thwepo-file-upload');

	if (productNotice) {
		setTimeout(() => {
			productNotice.style.display = 'none';
		}, 5000);
	}

	const filePreviewMutationCallback = (mutationsList) => {
		mutationsList.forEach((mutation) => {
			if (mutation.type !== 'childList' || mutation.addedNodes.length === 0) {
				return;
			}

			mutation.addedNodes.forEach((node) => {
				if (
					!node.classList ||
					!node.classList.contains('thwepo-uploaded-item')
				) {
					return;
				}

				const removeButton = node.querySelector('.thwepo-remove-image');
				if (removeButton) {
					removeButton.textContent = '\u00D7';
					removeButton.setAttribute('title', 'Remove uploaded file');
				}
			});
		});
	};

	if (thwepoFileInput) {
		// retrieve allowedFileTypes from global wpPostData object
		const allowedFileTypes = wpPostData.allowedFileTypes || 'image/*,.pdf'; // expects a comma-separated string of allowed file types, e.g. 'image/*,application/pdf'
		const filePreviewContainer = singleProductPage.querySelector(
			'.thwepo-preview-file',
		);
		const filePreviewObserver = new MutationObserver(
			filePreviewMutationCallback,
		);
		filePreviewObserver.observe(filePreviewContainer, {
			childList: true,
		});
		thwepoFileInput.setAttribute('accept', allowedFileTypes);
		if (thwepoFileInput.hasAttribute('multiple')) {
			thwepoFileInput.removeAttribute('multiple');
		}
	}
};

export default singleProduct;
